// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import axios from './axios'
import VueAxios from 'vue-axios'
import store from './store'
import VueMoment from 'vue-moment'
import 'es6-promise/auto'
import Raven from 'raven-js'
import RavenVue from 'raven-js/plugins/vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import 'material-icons/iconfont/material-icons.css'
import countTo from 'vue-count-to'
import VTooltip from 'v-tooltip'

Vue.use(VTooltip)

Vue.use(Vuetify)
import en from 'vuetify/es5/locale/en'
import dk from './dk.ts'

Vue.component('count-to', countTo)

Raven
    .config('https://e19fb0949740b65105e98a6b497e4e1f@o81729.ingest.sentry.io/4506218544693248')
    .addPlugin(RavenVue, Vue)
    .install()
Vue.prototype.$raven = Raven

import vueSeo from '@deveodk/vue-seo'
Vue.use(vueSeo)

Vue.use(VueAxios, axios)

import VueToastr from '@deveodk/vue-toastr'
import '@deveodk/vue-toastr/dist/@deveodk/vue-toastr.css'
Vue.use(VueToastr, {
    defaultPosition: 'toast-bottom-right',
    defaultType: 'info',
    defaultTimeout: 5000
})

import VueGoodTablePlugin from 'vue-good-table'
import 'vue-good-table/dist/vue-good-table.css'
Vue.use(VueGoodTablePlugin)

import VueSweetalert2 from 'vue-sweetalert2'
import 'sweetalert2/dist/sweetalert2.min.css'
Vue.use(VueSweetalert2)

import VModal from 'vue-js-modal'
Vue.use(VModal)

Vue.component('box-helper', require('@/components/elements/BoxHelper.vue'))
Vue.component('no-data', require('@/components/elements/NoData.vue'))
Vue.component('box-loading', require('@/components/elements/BoxLoading.vue'))
Vue.component('offline', require('@/components/core/offline.vue'))
Vue.component('loader', require('@/components/layout/loader.vue'))
Vue.component('title-block', require('@/components/elements/title.vue'))
Vue.component('summary-card', require('@/components/elements/SummaryCard.vue'))
Vue.component('number-card', require('@/components/elements/NumberCard.vue'))
Vue.component('login', require('@/pages/login/login.vue'))
Vue.component('table-card', require('@/components/elements/TableCard.vue'))
Vue.component('graph-card', require('@/components/elements/GraphCard.vue'))
Vue.component('projectTypeRevenue-table', require('@/components/tables/projects/typesRevenue.vue'))
Vue.component('showTypeRevenue-table', require('@/components/tables/projects/showTypeRevenue.vue'))
Vue.component('closedProjects-table', require('@/components/tables/projects/closed.vue'))
Vue.component('offerProjects-table', require('@/components/tables/projects/offer.vue'))
Vue.component('ongoingProjects-table', require('@/components/tables/projects/ongoing.vue'))
Vue.component('snoozedProjects-table', require('@/components/tables/projects/snoozed.vue'))
Vue.component('claimsProjects-table', require('@/components/tables/projects/claims.vue'))
Vue.component('openProjects-table', require('@/components/tables/projects/open.vue'))
Vue.component('noInvoiceProjects-table', require('@/components/tables/projects/noInvoice.vue'))
Vue.component('unpaidInvoices-table', require('@/components/tables/invoices/unpaid.vue'))
Vue.component('view-toggle', require('@/components/elements/viewToggle.vue'))
Vue.component('coming-soon', require('@/components/elements/comingSoon.vue'))
Vue.component('content-switch', require('@/components/elements/contentSwitch.vue'))
Vue.component('exceededPayments-table', require('@/components/tables/invoices/exceededPayments.vue'))
Vue.component('d-tooltip', require('@/components/elements/dTooltip.vue'))
Vue.component('budget-tooltip', require('@/components/elements/BudgetTooltip.vue'))
Vue.component('project-tooltip', require('@/components/elements/ProjectTooltip.vue'))
Vue.component('minuba-budget-tooltip', require('@/components/elements/MinubaBudgetTooltip.vue'))
Vue.component('all-invoices', require('@/components/tables/invoices/allInvoices.vue'))

Vue.use(VueMoment)
require('moment/locale/da')

Vue.filter('truncate', (input) => {
    if (input.length > 50) {
        return input.slice(0, 50) + ' ...'
    } else {
        return input.slice(0, 50)
    }
})

Vue.filter('currency', input => {
    if (!input) {
        return '0 kr.'
    }
    input = Math.round(input)
    return input.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ' kr.'
})

Vue.filter('realCurrency', input => {
    if (!input) {
        return 0 + ' kr.'
    }
    input = Math.round(input)
    return input.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ' kr.'
})

Vue.filter('number', input => {
    if (!input) {
        return '-'
    }
    input = Math.round(input)
    return input.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
})

Vue.filter('realNumber', input => {
    if (!input) {
        return 0
    }
    input = Number(input)
    if (!Number.isInteger(input)) {
        input = input.toFixed(2)
    }
    // input = Number(input).toFixed(2)
    return input
})

Vue.filter('numberWithDecimals', input => {
    if (!input) {
        return '-'
    }
    // input = Math.round(input)
    input = Number(input).toFixed(2)
    return input.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
})

// Coverage ratio is stored as it is, but never shown below 0.
Vue.filter('coveragePercent', input => {
    return Math.max(0, Math.round(Number(input) || 0))
})

Vue.filter('rounded', input => {
    if (!input) {
        return 0
    }
    return Math.round(input)
})

Vue.config.productionTip = false

Vue.router = router

Vue.use(require('@websanova/vue-auth'), {
    auth: require('@/auth/bearer_driver.js'),
    http: require('@websanova/vue-auth/drivers/http/axios.1.x.js'),
    router: require('@websanova/vue-auth/drivers/router/vue-router.2.x.js'),
    parseUserData: function (data) {
        return data
    },
    authRedirect: {path: '/login'},
    refreshData: {enabled: false},
    loginData: {url: '/login'},
    logoutData: {url: '/logout', method: 'GET'},
    fetchData: {url: process.env.API_URL + '/me'}
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  vuetify: new Vuetify({
    icons: {
        iconfont: 'md'
    },
    lang: {
        locales: { en, dk },
        current: 'dk'
    }
  }),
  store,
  router,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js